import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";

Vue.use(Vuex);

export default {
  state: {
    miscData: {},
    miscDataReady: false,
  },
  actions: {
    async getMiscData(context, language) {
      let url = "/umbraco/api/ProjectenModule/GetMiscData";
      if(language != "") {
        // add the language to the querystring
        url += "?language=" + language;
      } // else language == "". The default language will be used.
      
      await axios
        .get(url)
        .then(function(response) {
          context.commit("miscData", response.data);
          context.commit("miscDataReady", true);
        })
        .catch(function(error) {
          // handle error
          context.commit("miscDataReady", false);
        })
        .then(function() {
          // always executed
        });
    },
  },
  mutations: {
    miscData(state, payload) {
      state.miscData = payload;
    },
    miscDataReady(state, payload) {
      state.miscDataReady = payload;
    },
  },
};
